import React, { useCallback, useContext } from 'react'
import { Context } from '..';
import { Button } from '@themesberg/react-bootstrap';

export const TableRow = (props) => {
  const {
    id,
    title,
    subTitle,
  } = props;

  const { _, dispatch } = useContext(Context);

  const handleUpdate = useCallback(() => {
    dispatch({
      type: 'OPEN_ADD_POPUP',
      payload: {
        id: id,
        title: title,
        subTitle: subTitle,
      }
    })
  }, [])

  const handleDelete = useCallback(() => {
    dispatch({
      type: 'OPEN_CONFIRM_POPUP',
      payload: {
        id: id,
      }
    })
  }, [])

  return (
    <tr>
      <td className="text-center">
        <Button variant='danger' onClick={handleDelete}>
          Xóa
        </Button>
        &nbsp;
        &nbsp;
        &nbsp;
        <Button variant='info' onClick={handleUpdate}>
          Sửa
        </Button>
      </td>
      <td className="text-center">
        {title}
      </td>
      <td className="text-center">
        {subTitle}
      </td>
    </tr>
  );
};